import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators
} from '@angular/forms';
import {FirebaseService} from '../app/firebase.service';
import {Reise} from '../app/types';
import {User} from '../app/user';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Texte} from "../common/texte";
import {environment} from "../environments/environment";
import {GruppenBuchung} from "./buchung";

@Component({
  selector: 'app-buchung',
  templateUrl: './buchung.component.html',
  styles: []
})
export class BuchungComponent implements OnInit, OnChanges {
  @Input()
  user: User;
  @Input()
  admin: boolean;
  texte = new Texte(environment);
  stammdatenFormGroup: FormGroup;
  weitereTeilnehmerFormGroup: FormGroup;
  reisenFormGroup: FormGroup;
  optionenFormGroup: FormGroup;
  rechnungFormGroup: FormGroup;
  reisen: Observable<Reise[]>;
  reisenFormError = {name: {value: 'Bitte Reise(n) auswählen.'}};
  reisenFormValid = new BehaviorSubject<ValidationErrors|null>(this.reisenFormError);
  private userSubscription: Subscription;
  // TODO move to User
  private _gruppenBuchung: GruppenBuchung;

  constructor(public service: FirebaseService,
              private formBuilder: FormBuilder,
              private router: Router) {
    this.reisen = this.service.getBuchbareReisen();
  }

  ngOnInit() {
    this.stammdatenFormGroup = this.formBuilder.group({
      stammdaten: []
    });
    this.weitereTeilnehmerFormGroup = this.formBuilder.group({
      teilnehmer: []
    });
    this.reisenFormGroup = this.formBuilder.group({
      reisenCtrl: ['', , this.reisenValidator()]
    });
    this.optionenFormGroup = this.formBuilder.group({
      optionen: []
    });
    this.rechnungFormGroup = this.formBuilder.group({
      agb: [false, Validators.required]
    });
    if (!this.admin) {
      this.userSubscription = this.service.user.subscribe(user => {
        this.user = user;
        if (user) {
          this._gruppenBuchung = new GruppenBuchung(this.user);
        }
      });
    }
  }

  ngOnChanges() {
    if (this.admin) {
      this._gruppenBuchung = new GruppenBuchung(this.user);
    }
  }

  get buchung(): GruppenBuchung {
    return this._gruppenBuchung;
  }

  reiseSelected(reise, selected: boolean) {
    if (selected) {
      this.buchung.addReise(reise);
    } else {
      this.buchung.removeReise(reise);
    }
    this.reisenFormValid.next(this.buchung.reisen.length === 0 ? this.reisenFormError : null);
  }
  isReiseSelected(reise): boolean {
    return this.buchung.reisen.includes(reise);
  }
  reisenValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors|null> => {
      return this.reisenFormValid;
    };
  }

  sendAnfrage() {
    if (!this.rechnungFormGroup.valid) {
      return;
    }
    this.service.addUserAnfrage(this.buchung).then(() => {
      this._gruppenBuchung = null;
      const path = this.admin ? '/admin/kunde' : '/konto';
      this.router.navigate([path]);
    });
  }
}
